import type { ModuleTagEntry } from './index';

/** PET Image module tags. */
export const tags: ModuleTagEntry[] = [
  'FrameReferenceTime',
  'ActualFrameDuration',
];
